var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.15 13.3511L20.5776 16.6782L22.2597 17.4731L17.1006 21.5474L18.673 18.2202L16.991 17.4253L22.15 13.3511Z",
    fill: "#c9c9c9",
    stroke: "#c9c9c9",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99238 1.21333C5.99238 0.830413 5.68196 0.519997 5.29905 0.519997C4.91613 0.519997 4.60571 0.830413 4.60571 1.21333V7.54H0.693333C0.310416 7.54 0 7.85041 0 8.23333C0 8.61625 0.310416 8.92666 0.693333 8.92666H1.15143V11.7433C1.15143 13.7855 1.94969 15.7462 3.37407 17.1935C4.63484 18.4747 6.29499 19.2606 8.06 19.4245V24.6133C8.06 24.9962 8.37042 25.3067 8.75333 25.3067C9.13625 25.3067 9.44667 24.9962 9.44667 24.6133V19.4245C10.347 19.3409 11.2201 19.0954 12.0267 18.7049C11.9827 18.3695 11.96 18.0274 11.96 17.68C11.96 17.5026 11.9659 17.3266 11.9776 17.1521C11.0128 17.748 9.89885 18.07 8.75333 18.07C7.10856 18.07 5.52887 17.4062 4.3624 16.2209C3.19556 15.0352 2.5381 13.4248 2.5381 11.7433V8.92666H14.9686V11.5247C15.3972 11.1905 15.8617 10.9002 16.3552 10.6604V8.92666H16.8133C17.1963 8.92666 17.5067 8.61625 17.5067 8.23333C17.5067 7.85041 17.1963 7.54 16.8133 7.54H12.901V1.21333C12.901 0.830413 12.5905 0.519997 12.2076 0.519997C11.8247 0.519997 11.5143 0.830413 11.5143 1.21333V7.54H5.99238V1.21333Z",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 22.776C22.458 22.776 24.856 20.378 24.856 17.42C24.856 14.462 22.458 12.064 19.5 12.064C16.542 12.064 14.144 14.462 14.144 17.42C14.144 20.378 16.542 22.776 19.5 22.776ZM19.5 23.92C23.0899 23.92 26 21.0098 26 17.42C26 13.8301 23.0899 10.92 19.5 10.92C15.9101 10.92 13 13.8301 13 17.42C13 21.0098 15.9101 23.92 19.5 23.92Z",
    fill: "#c9c9c9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#c9c9c9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.0f4422941cf34b3743c11b9d570799ab.svg";
export { ForwardRef as ReactComponent };